import gql from 'graphql-tag'

export const GET_ALL_PENDING_ADVISORY_FOR_ASSOCIATE = gql`
  query Query($isMenu: Boolean) {
    getPendingAdvisoryForAssociate(isMenu: $isMenu)
  }
`
